import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M22.5 15.625c0-.69.56-1.25 1.25-1.25h5a1.25 1.25 0 1 1 0 2.5h-5c-.69 0-1.25-.56-1.25-1.25ZM10 15.625c0-.69.56-1.25 1.25-1.25h5a1.25 1.25 0 1 1 0 2.5h-5c-.69 0-1.25-.56-1.25-1.25Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M13.75 11.875c.69 0 1.25.56 1.25 1.25v5a1.25 1.25 0 1 1-2.5 0v-5c0-.69.56-1.25 1.25-1.25Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M26.875 6.203a9.375 9.375 0 0 1 .003 18.75h-.003l-9.599.044-6.38 7.06-.927-.838.886.882a5.625 5.625 0 0 1-9.523-4.962l.004-.019 2.56-13.13a9.39 9.39 0 0 1 9.226-7.74m13.753-.047v1.25-1.25Zm0 2.5-13.747.047a6.89 6.89 0 0 0-6.772 5.687l-1.23-.218 1.226.239-2.56 13.13a3.125 3.125 0 0 0 5.272 2.768l6.728-7.444c.235-.261.57-.41.921-.412l10.157-.047h.005a6.875 6.875 0 0 0 .002-13.75h-.002Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M34.637 12.945a1.25 1.25 0 0 1 1.465.989l2.563 13.187.003.018a5.625 5.625 0 0 1-9.522 4.962l.885-.882-.929.836-6.75-7.5a1.25 1.25 0 0 1 1.858-1.672l6.727 7.474a3.125 3.125 0 0 0 5.272-2.769L33.648 14.41a1.25 1.25 0 0 1 .989-1.465Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }